export default "__VITE_ASSET__8dTrLvkI__"